import { Route } from '@angular/router';
import { authGuard } from './auth/auth.guard';
import { PendingChangesGuard } from './core/guards/pending-changes.guard';

export const appRoutes: Route[] = [
    {
        path: '',
        loadComponent: () => import(`./pages/home/home.component`).then(c => c.HomeComponent),
        title: 'Home - TruSmart Commercial',
        canActivate: [authGuard],
        children: [],
    },
    {
        path: 'customers',
        title: 'Customers - TruSmart Commercial',
        canActivate: [authGuard],
        children: [
            {
                path: 'new',
                loadComponent: () => import('./pages/customer-new/customer-new.component').then(c => c.CustomerNewComponent),
                title: 'New Customer - TruSmart Commercial',
            },
            {
                path: ':id',
                loadComponent: () => import('./pages/customer-details/customer-details.component').then(c => c.CustomerDetailsComponent),
                title: 'Customer - TruSmart Commercial',
            },
            {
                path: ':id/edit',
                loadComponent: () => import('./pages/customer-new/customer-new.component').then(c => c.CustomerNewComponent),
                title: 'Edit Customer - TruSmart Commercial',
            },
            {
                path: '',
                loadComponent: () => import('./pages/customer-list/customer-list.component').then(c => c.CustomerListComponent),
                title: 'Customers - TruSmart Commercial',
            },
        ],
    },
    {
        path: 'user-list',
        loadComponent: () => import('./pages/user-list/user-list.component').then(c => c.UserListComponent),
        title: 'Users - TruSmart Commercial',
        canActivate: [authGuard],
    },
    {
        path: 'shipping-methods',
        loadComponent: () => import('./pages/shipping-methods-list/shipping-methods-list.component').then(c => c.ShippingMethodsListComponent),
        title: 'Shipping methods - TruSmart Commercial',
        canActivate: [authGuard],
    },
    {
        path: 'payment-conditions',
        loadComponent: () => import('./pages/payment-conditions-list/payment-conditions-list.component').then(c => c.PaymentConditionsList),
        title: 'Payment conditions - TruSmart Commercial',
        canActivate: [authGuard],
    },
    {
        path: 'raw-materials',
        loadComponent: () => import('./pages/raw-materials-list/raw-materials-list.component').then(c => c.RawMaterialsListComponent),
        title: 'Raw Materials - TruSmart Commercial',
        canActivate: [authGuard],
    },
    {
        path: 'articles',
        title: 'Articles - TruSmart Commercial',
        canActivate: [authGuard],
        children: [
            {
                path: 'new',
                loadComponent: () => import('./pages/article-new/article-new.component').then(c => c.ArticleNewComponent),
                title: 'New Article - TruSmart Commercial',
            },
            {
                path: ':id',
                loadComponent: () => import('./pages/article-details/article-details.component').then(c => c.ArticleDetailsComponent),
                title: 'Article - TruSmart Commercial',
            },
            {
                path: ':id/edit',
                loadComponent: () => import('./pages/article-new/article-new.component').then(c => c.ArticleNewComponent),
                title: 'Edit Article - TruSmart Commercial',
            },
            {
                path: '',
                loadComponent: () => import('./pages/articles-list/articles-list.component').then(c => c.ArticlesListComponent),
                title: 'Articles - TruSmart Commercial',
            },
        ],
    },
    {
        path: 'report-designer',
        loadComponent: () => import(`./components/library/report-designer/report-designer.component`).then(c => c.ReportDesignerComponent),
        title: 'Report Designer - TruSmart Commercial',
        canActivate: [authGuard],
        data: { breadcrumb: 'Report Designer' },
    },
    {
        path: 'orders',
        title: 'Customer orders - TruSmart Commercial',
        canActivate: [authGuard],
        children: [
            {
                path: 'new',
                loadComponent: () => import('./pages/order-new/order-new.component').then(c => c.OrderNewComponent),
                title: 'New Order - TruSmart Commercial',
            },
            {
                path: 'by-number/:customerOrderNumber',
                loadComponent: () =>
                    import('./pages/order-by-number-redirect/order-by-number-redirect.component').then(c => c.OrderByNumberRedirectComponent),
                title: 'Order - TruSmart Commercial',
            },
            {
                path: 'by-external-number/:externalReferenceNo',
                loadComponent: () =>
                    import('./pages/order-by-number-redirect/order-by-number-redirect.component').then(c => c.OrderByNumberRedirectComponent),
                title: 'Order - TruSmart Commercial',
            },
            {
                path: ':id',
                loadComponent: () => import('./pages/order-details/order-details.component').then(c => c.OrderDetailsComponent),
                title: 'Order - TruSmart Commercial',
            },
            {
                path: ':id/edit',
                loadComponent: () => import('./pages/order-new/order-new.component').then(c => c.OrderNewComponent),
                title: 'Edit Order - TruSmart Commercial',
            },
            {
                path: ':id/dispositions',
                loadComponent: () => import('./pages/order-dispositions/order-dispositions.component').then(c => c.OrderDispositionsComponent),
                title: 'Order Dispositions - TruSmart Commercial',
                data: { breadcrumb: 'Dispositions' },
            },
            {
                path: '',
                loadComponent: () => import('./pages/orders-list/orders-list.component').then(c => c.OrdersListComponent),
                title: 'Customer orders - TruSmart Commercial',
            },
        ],
    },
    {
        path: 'deliveries',
        title: 'Deliveries - TruSmart Commercial',
        canActivate: [authGuard],
        data: { breadcrumb: 'Deliveries' },
        children: [
            {
                path: 'new',
                loadComponent: () => import('./pages/delivery-new/delivery-new.component').then(c => c.DeliveryNewComponent),
                title: 'New Delivery - TruSmart Commercial',
                data: { breadcrumb: 'New Delivery' },
            },
            {
                path: ':id',
                loadComponent: () => import('./pages/delivery-details/delivery-details.component').then(c => c.DeliveryDetailsComponent),
                title: 'Delivery - TruSmart Commercial',
                data: { breadcrumb: 'Delivery' },
            },
            {
                path: ':id/edit',
                loadComponent: () => import('./pages/delivery-new/delivery-new.component').then(c => c.DeliveryNewComponent),
                title: 'Edit Delivery - TruSmart Commercial',
                data: { breadcrumb: 'Edit Delivery' },
            },
            {
                path: '',
                loadComponent: () => import('./pages/deliveries-list/deliveries-list.component').then(c => c.DeliveriesListComponent),
                title: 'Deliveries - TruSmart Commercial',
            },
        ],
    },
    {
        path: 'invoices',
        title: 'Invoices - TruSmart Commercial',
        canActivate: [authGuard],
        children: [
            {
                path: 'new',
                loadComponent: () => import('./pages/invoice-new/invoice-new.component').then(c => c.InvoiceNewComponent),
                title: 'New Invoice - TruSmart Commercial',
                data: { breadcrumb: 'New Invoice' },
            },
            {
                path: ':id/edit',
                loadComponent: () => import('./pages/invoice-new/invoice-new.component').then(c => c.InvoiceNewComponent),
                title: 'Edit Invoice - TruSmart Commercial',
                data: { breadcrumb: 'Edit Invoice' },
            },
            {
                path: ':id',
                loadComponent: () => import('./pages/invoice-details/invoice-details.component').then(c => c.InvoiceDetailsComponent),
                title: 'Invoice - TruSmart Commercial',
            },
            {
                path: '',
                loadComponent: () => import('./pages/invoices-list/invoices-list.component').then(c => c.InvoicesListComponent),
                title: 'Invoices - TruSmart Commercial',
            },
        ],
    },
    {
        path: 'order-history',
        loadComponent: () => import(`./pages/order-history/order-history`).then(c => c.OrderHistory),
        title: 'Order History - TruSmart Commercial',
        canActivate: [authGuard],
    },
    {
        path: 'login',
        loadComponent: () => import(`./auth/login/login.component`).then(c => c.LoginComponent),
        title: 'Login - TruSmart Commercial',
    },
    {
        path: 'profile',
        loadComponent: () => import(`./auth/profile/profile.component`).then(c => c.ProfileComponent),
        title: 'Profile - TruSmart Commercial',
        canActivate: [authGuard],
    },
    {
        path: 'settings',
        loadComponent: () => import(`./pages/settings/settings.component`).then(c => c.SettingsComponent),
        title: 'Settings - TruSmart Commercial',
        canActivate: [authGuard],
        children: [
            {
                path: '',
                pathMatch: 'full',
                redirectTo: 'general',
            },
            {
                path: 'general',
                loadComponent: () =>
                    import('./components/library/settings-general/settings-general.component').then(m => m.SettingsGeneralComponent),
                canDeactivate: [PendingChangesGuard],
            },
            {
                path: 'notifications',
                loadComponent: () =>
                    import('./components/library/settings-notification/settings-notification.component').then(
                        m => m.SettingsNotificationComponent
                    ),
                canDeactivate: [PendingChangesGuard],
            },
            {
                path: 'features',
                loadComponent: () =>
                    import('./components/library/settings-feature/settings-feature.component').then(m => m.SettingsFeatureComponent),
                canDeactivate: [PendingChangesGuard],
            },
            {
                path: 'actions',
                loadComponent: () =>
                    import('./components/library/settings-action/settings-action.component').then(m => m.SettingsActionComponent),
                canDeactivate: [PendingChangesGuard],
            },
            {
                path: 'number-format',
                loadComponent: () =>
                    import('./components/library/settings-number-format/settings-number-format').then(m => m.SettingsNumberFormat),
                canDeactivate: [PendingChangesGuard],
            },
        ],
    },
    {
        path: 'roles',
        loadComponent: () => import(`./pages/roles/roles.component`).then(c => c.RolesComponent),
        title: 'Roles - TruSmart Commercial',
        canActivate: [authGuard],
    },
    {
        path: 'geo',
        loadComponent: () => import(`./pages/geo-format/geo-format.component`).then(c => c.GeoFormatComponent),
        title: 'Geo Format - TruSmart Commercial',
        canActivate: [authGuard],
    },
    {
        path: 'stl',
        loadComponent: () => import(`./pages/stl-format/stl-format.component`).then(c => c.StlFormatComponent),
        title: 'Stl Format - TruSmart Commercial',
        canActivate: [authGuard],
    },
    {
        path: 'icons',
        loadComponent: () => import(`./pages/icons/icons.component`).then(c => c.IconsComponent),
        title: 'Icons - TruSmart Commercial',
    },
    {
        path: 'unauthorized',
        loadComponent: () => import(`./pages/unauthorized/unauthorized.component`).then(c => c.UnauthorizedComponent),
        title: 'Access Denied - TruSmart Commercial',
    },
    {
        path: 'access-restricted',
        loadComponent: () => import(`./pages/access-restricted/access-restricted.component`).then(c => c.AccessRestrictedComponent),
        title: 'Access Restricted - TruSmart Commercial',
    },
    {
        path: '**',
        loadComponent: () => import(`./pages/not-found/not-found.component`).then(c => c.NotFoundComponent),
        title: 'Page Not Found - TruSmart Commercial',
    },
];
